import React from "react"
import ReactDOM from "react-dom"
import "./i18n"
import "./index.css"
import App from "./App.jsx"
// Recoil
import { RecoilRoot } from "recoil"
// import reportWebVitals from "./reportWebVitals"

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root")
)
